export default function (obj) {
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const i in obj) {
    return false;
  }
  return true;
}
